import { Direction } from "radix-ui";

import type { DirectionProviderProps } from "./types";

const DirectionProvider = ({ children, dir }: DirectionProviderProps) => (
  <Direction.Provider dir={dir}>{children}</Direction.Provider>
);

DirectionProvider.displayName = "DirectionProvider";

export { DirectionProvider };
